import { FormattedMessage } from "react-intl"
import classNames from "classnames"
import { Tooltip } from "../../../common"

// Hooks
import { useFetchCVById } from "../../../../hooks/useFetchCVById"

// Components
import CandidateScore from "../../../common/Candidate"
import { CVFile, CustomButton, Spinner } from "../../../common"
import Profile from "./Profile"

// Utils
import { getRating } from "../../../../util/util"

// Constants
import { GA_EVENTS } from "../../../../constants/analytics"
import { useSelector } from "react-redux"


const actionItems = [
  {
    name: "common.matchScore",
    key: "job-match",
    trackingEvent: GA_EVENTS.JOB_MATCHES.ACTION_MATCH_SCORE,
  },
  {
    name: "common.profile",
    key: "profile",
    trackingEvent: GA_EVENTS.JOB_MATCHES.ACTION_PROFILE_TAB,
  },
  {
    name: "common.cv",
    key: "cv",
    trackingEvent: GA_EVENTS.JOB_MATCHES.ACTION_CV,
  },
]

const Candidate = ({ tab, matchInfo, switchTab }) => {
  const { id, person_id } = matchInfo

  const storedCVData = useSelector((state) => state.cv.cvs?.find(cv => cv.id === person_id))

  const { data: fetchedCVData } = useFetchCVById({
    id,
    enabled: id && !matchInfo?.cv && !storedCVData && tab !== "job-match",
    onErrorCallback: () => switchTab("job-match")
  })

  const cvData = matchInfo?.cv || storedCVData || fetchedCVData

  const jobScore = Math.round(matchInfo?.summary_score);

  const actionItemsNavButtons = actionItems.map((action) => {
    // Show only the job-match tab if there is no cv data
    if (!cvData && action.key !== "job-match") return null;

    return (
      <CustomButton
        key={action.key}
        className={classNames("matches-page__nav-btn", {
          selected: tab === action.key,
        })}
        onClick={() => switchTab(action.key)}
        trackingEvent={action.trackingEvent}
      >
        <FormattedMessage id={action.name} />
      </CustomButton>
    );
  }).filter(Boolean);

  return (
    <>
      <div className="matches-page__content">
        <div className="matches-page__header">
          {tab === "job-match" && (
            <div style={{ background: "white" }} className="score">
              <div style={{ opacity: (jobScore / 10) + 0.2 }} className="score" >
                <div className={classNames("score-value", {
                  "score-value--low": jobScore < 6,
                  "score-value--high": jobScore >= 6,
                })}>
                  {jobScore}
                </div>
              </div>
            </div>
          )}

          <div className="matches-page__header-info">
            <h2 className="matches-page__name h2">
              {cvData?.information
                ? `${cvData?.information?.first_name} ${cvData?.information?.last_name}`
                : <Tooltip tooltip={<FormattedMessage id="candidate.notFound" />}>
                    <span className={classNames("matches-page__resume-not-found")}>
                      <FormattedMessage id="common.resumeNotFound" />
                    </span>
                  </Tooltip>
                  
              }
            </h2>
            {tab === "job-match" && (
              <h2 className="matches-page__name h2">
                <FormattedMessage id={getRating(jobScore)} />
              </h2>
            )}
          </div>

          <div className="actions">
            <div className="matches-page__nav-btns">
              {actionItemsNavButtons}
            </div>
          </div>
        </div>

        {tab === "job-match" && (
          <CandidateScore matchData={matchInfo} cvData={cvData} />
        )}

        {["cv", "profile"].includes(tab) && !cvData && <Spinner />}

        {tab === "cv" && <CVFile url={cvData.cv_url} />}

        {tab === "profile" && cvData && (
          <Profile
            cv={cvData}
            jobData={matchInfo}
            showCheckbox={false}
          />
        )}
      </div>
    </>
  )
}

export default Candidate
